module.exports = __webpack_public_path__ + "img/m9-white.90988019.png";